import { Card } from "@onengine/component-library";
import type { ReactNode } from "react";
import clsx from "clsx";

import { useFileManagerUI } from "../../FileManagerContext/FileManagerUIContext.ts";
import styles from "./FileManagerCard.module.scss";

export interface FileManagerCardProps {
  children: ReactNode;
  subtreeLeft?: ReactNode;
  subtreeRight?: ReactNode;
}

export function FileManagerCard({ children, subtreeLeft, subtreeRight }: FileManagerCardProps) {
  const { isTreeVisible } = useFileManagerUI();
  const hasSubtree = !!subtreeLeft || !!subtreeRight;

  return (
    <Card data-slot={"file-manager-card"} padding={0} className={styles.card}>
      <div className={clsx(styles.inner, hasSubtree && styles.withSubtree)}>
        {subtreeLeft && (
          <div
            className={clsx(
              styles.subtree,
              styles.subtreeLeft,
              !isTreeVisible && styles.subtreeHidden,
            )}
          >
            {subtreeLeft}
          </div>
        )}
        <div className={clsx(styles.mainContent, hasSubtree && styles.mainContentConstrained)}>
          {children}
        </div>
        {subtreeRight && (
          <div className={clsx(styles.subtree, styles.subtreeRight)}>{subtreeRight}</div>
        )}
      </div>
    </Card>
  );
}
